import React from 'react'
import classes from './styles.module.scss'
// import { FormattedMessage } from 'react-intl'
// import messages from './messages'
import { WhiteSpace, Toast, Flex, InputItem } from 'antd-mobile'
import { CopyToClipboard } from 'react-copy-to-clipboard'
import _ from 'lodash'

export default class InviteCode extends React.Component {
  // constructor(props) {
  //   super(props)
  //   this.state = {
  //     foo: 'foo'
  //   }
  // }

  handleCopy = () => {
    Toast.info('Copy successfully!')
  }

  render() {
    const {
      kycStatus,
      inviteCode,
      scene,
      isNotEdit,
      form,
      text = 'Referral Code'
    } = this.props
    if (scene === 'inviter') {
      return (
        <div className={`text-center ${classes.componentsInviteCode}`}>
          <p className='font-sm white'>
            <b>{text}</b>
          </p>
          <WhiteSpace size='sm' />
          {kycStatus === 'KYC_FINISH' ? (
            <CopyToClipboard onCopy={this.handleCopy} text={inviteCode}>
              <h3>
                {inviteCode}
                <i className='iconfont iconcopy font-md' />
              </h3>
            </CopyToClipboard>
          ) : (
            <h3>？？？</h3>
          )}
        </div>
      )
    }
    if (isNotEdit) {
      if (inviteCode) {
        return (
          <div className={`text-center ${classes.componentsInviteCode}`}>
            <p className='font-sm white'>
              <b>Referral Code</b>
            </p>
            <WhiteSpace size='sm' />
            <h3>{inviteCode}</h3>
          </div>
        )
      }
      return null
    }
    return (
      <Flex
        direction='row'
        justify='between'
        className={classes.componentsInviteCodeInput}
      >
        <b>Referral Code</b>
        <Flex.Item>
          {form.getFieldDecorator('inviteCode', {
            initialValue: _.toUpper(inviteCode),
            rules: [
              {
                required: true,
                pattern: /^[0-9A-Z]{3,8}$/
              }
            ],
            normalize: (value, prev) => {
              if (/^[0-9A-Za-z]{0,8}$/.test(value)) {
                return _.toUpper(value)
              }
              return prev
            }
          })(
            <InputItem
              maxLength='8'
              placeholder='Please enter'
            />
          )}
        </Flex.Item>
      </Flex>
    )
  }
}
